import * as React from 'react'
import { ReactElement } from 'react'
import { Field, InfoLabel, Input, LabelProps } from '@fluentui/react-components'
import { DocketProceedingDto, DocketProceedingType } from './DocketProceedingForm'
import { useFormikContext } from 'formik'
import { DocketProceedingPanelProps } from './FormContainer'
import JudicialInstitutionCombobox from '../../Combobox/JudicialInstitutionCombobox'
import EnumCombobox from '../../Combobox/EnumCombobox'
import UserCombobox from '../../Combobox/UserCombobox'
import Textarea from '../../Text/TextArea'

export default function MasterDataPanel(props: DocketProceedingPanelProps): ReactElement {
    const { values, setFieldValue, errors } = useFormikContext<DocketProceedingDto>()

    return (
        <div className={props.styles.formRow}>
            <Field
                label="Type"
                required
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.type ? 'error' : undefined}
                validationMessage={errors.type}
            >
                <EnumCombobox<DocketProceedingType>
                    entities={[
                        DocketProceedingType.SubdistrictCourt,
                        DocketProceedingType.DistrictCourt,
                        DocketProceedingType.CourtOfAppeal,
                        DocketProceedingType.SupremeCourt,
                    ]}
                    selectedOptions={[values.type]}
                    labelKeyPrefix={'base.docketproceedingtype'}
                    onOptionSelect={(_, data) => {
                        setFieldValue('type', data.selectedOptions?.[0])
                        props.selected.type = DocketProceedingType[data.selectedOptions?.[0]]
                    }}
                />
            </Field>
            <Field
                label={
                    {
                        children: (_, slotProps: LabelProps) => (
                            <InfoLabel
                                {...slotProps}
                                info={
                                    'Neem contact op met support om de lijst van justitiële instellingen aan te passen.'
                                }
                            >
                                Justitiële instelling
                            </InfoLabel>
                        ),
                    } as unknown // The Fluent UI types do not define this properly, therefore suppress any TS errors.
                }
                required
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.judicialInstitutionId ? 'error' : undefined}
                validationMessage={errors.judicialInstitutionId}
            >
                <JudicialInstitutionCombobox
                    dataPromise={props.judicialInstitutions}
                    selectedOptions={[values.judicialInstitutionId]}
                    onOptionSelect={(_, data) => setFieldValue('judicialInstitutionId', data.selectedOptions?.[0])}
                />
            </Field>
            <Field
                label="Locatie"
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.location ? 'error' : undefined}
                validationMessage={errors.location}
            >
                <Input value={values.location || ''} onChange={(_, data) => setFieldValue('location', data.value)} />
            </Field>
            <Field
                label="Zaakkenmerk"
                required
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.proceedingNumber ? 'error' : undefined}
                validationMessage={errors.proceedingNumber}
            >
                <Input
                    value={values.proceedingNumber || ''}
                    onChange={(_, data) => setFieldValue('proceedingNumber', data.value)}
                />
            </Field>
            <Field
                label="Uitvoerder"
                required
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.userId ? 'error' : undefined}
                validationMessage={errors.userId}
            >
                <UserCombobox
                    selectedOptions={[values.userId]}
                    onOptionSelect={(_, data) => setFieldValue('userId', data.selectedOptions?.[0])}
                />
            </Field>
            {values.type === DocketProceedingType.CourtOfAppeal && (
                <Field
                    label="Status/Zaakstand"
                    orientation={props.orientation}
                    className={props.styles.field}
                    validationState={errors.status ? 'error' : undefined}
                    validationMessage={errors.status}
                >
                    <Input value={values.status || ''} onChange={(_, data) => setFieldValue('status', data.value)} />
                </Field>
            )}
            <Field
                label="Opmerking"
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.remark ? 'error' : undefined}
                validationMessage={errors.remark}
            >
                <Textarea
                    value={values.remark || ''}
                    onChange={(_, data) => setFieldValue('remark', data.value)}
                    autoAdjustHeight
                />
            </Field>
        </div>
    )
}
